import React, { ComponentType } from 'react';
import { Button, ButtonProps, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AppPermissions, useGetInitInfoQuery } from '../../generated/graphql';
import { checkAccess } from '../../utils';

export type ProtectedActionProps = ButtonProps & {
    permissions?: Partial<Pick<AppPermissions, 'backoffice' | 'warehouse'>>;
    component?: ComponentType<ButtonProps>;
};

const ProtectedAction = ({ permissions, component = Button, disabled, ...other }: ProtectedActionProps) => {
    const { data } = useGetInitInfoQuery({ fetchPolicy: 'cache-only' });
    const { t } = useTranslation();

    const Component = component;
    const hasAccess = data ? checkAccess(permissions, data.employeePermissions) : false;
    if(!hasAccess){
        return (
            <Tooltip title={t(`Not enough permissions`) as string} arrow>
                <div>
                    <Component {...other} disabled={!hasAccess} />
                </div>
            </Tooltip>
        );
    }

    return (
        <Component {...other} disabled={disabled || !hasAccess} />
    );
};

export default ProtectedAction;
